/**
 * Paige Scan's refusals in words: the agent answers a code (`scan_in_progress`), never shown as is. A scan already
 * on the wire is "another scan", not a "previous" one still finishing (CapturePoint f76c1cfa, the same slip).
 */
const REFUSALS: Record<string, string> = {
  scan_in_progress: 'Another scan is running. Wait for it to finish, then scan again.',
  no_such_device: 'That scanner is not connected now. Choose it again, or look for scanners again.',
  no_such_scan: 'That scan has already ended. Scan again.',
  too_soon: 'Paige Scan is busy for a moment. Try again.',
};

export function scanAgentProblem(error: unknown): string {
  if (!(error instanceof Error)) return 'Paige Scan did not answer';
  return REFUSALS[error.message] ?? error.message;
}
